<template>
    <div v-bind:class="(mode !== 'widget' ? 'home chat-mobile-app' : 'home')">
        <div class="container clearfix">
            <div class="chat">
                <div v-if="mode == 'widget'" class="chat-header clearfix" :style="{'background': $parent.primary_color, 'border-radius':'15px 15px 0 0'}">
                    <!-- <img
                        src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/195612/chat_avatar_01_green.jpg"
                        alt="avatar"
                    /> -->
                        
                    <div class="chat-about">
                        <div class="chat-with" style="display: flex; align-items: center; overflow: hidden;justify-content: space-between;">
                            {{widgetParapeters.descricao_canal}}
                            <!-- <img src="../assets/css/Jana.jpeg" alt="" style="margin-right: 60px; width: 10%;border-radius: 10px;"> -->
                        </div>
                        <div class="chat-num-messages"></div>
                        <i class="fas fa-times" style="cursor: pointer" @click="$parent.handleChatWindow"></i>
                    </div>

                </div>
                <!-- end chat-header -->
                <div v-bind:class="(mode !== 'widget' ? 'chat-messages-montreal chat-messages-mobile-app' : 'chat-messages')">
                    <div class="extension-not-supported" v-if="!extension">
                        Esse tipo de arquivo não é suportado!
                    </div>
                    <!--<div class="messages-overflow">-->
                    <!-- <div id="chat-history" v-bind:class="(mode !== 'widget' ? 'chat-history' : 'chat-history')"> 
                        <div class="chat-indisponivel" v-if="widgetParapeters.id_status != 1">Canal Inativado! Verifique com a Administração.</div>
                        <div class="chat-indisponivel" v-else-if="!(openingHoursChat.operatingChat)">{{openingHoursChat.msgOperatingChat}}</div>
                        <message-ballon
                            v-for="(msg, index) in mensagens"
                            :mensagem="msg"
                            :key="index"
                            :primary_color="$parent.primary_color"
                            :secondary_color="$parent.secondary_color"
                            :openingHoursChat="openingHoursChat"
                            @escolheOpcao="escolheOpcao"
                        >
                        </message-ballon>
                    -->
                    <!-- Condição para empresa Montreal -->
                    <div v-if="this.$parent.mode !='widget' && this.$parent.company == 100" v-bind:class="'chat-history-montreal'">
                        <div class="chat-indisponivel" v-if="widgetParapeters.id_status != 1">Canal Inativado! Verifique com a Administração.</div>
                        <div class="chat-indisponivel" v-else-if="!(openingHoursChat.operatingChat)">{{openingHoursChat.msgOperatingChat}}</div>
                        
                        <message-ballon-montreal
                            v-for="(msg, index) in mensagens"
                            :mensagem="msg"
                            :key="index"
                            :primary_color="$parent.primary_color"
                            :secondary_color="$parent.secondary_color"
                            :openingHoursChat="openingHoursChat"
                            @escolheOpcao="escolheOpcao"
                        >
                        </message-ballon-montreal>
                    </div>
                    <div v-else v-bind:class="'chat-history'">
                        <div class="chat-indisponivel" v-if="widgetParapeters.id_status != 1">Canal Inativado! Verifique com a Administração.</div>
                        <div class="chat-indisponivel" v-else-if="!(openingHoursChat.operatingChat)">{{openingHoursChat.msgOperatingChat}}</div>
                        <message-ballon
                            v-for="(msg, index) in mensagens"
                            :mensagem="msg"
                            :key="index"
                            :primary_color="$parent.primary_color"
                            :secondary_color="$parent.secondary_color"
                            :openingHoursChat="openingHoursChat"
                            @escolheOpcao="escolheOpcao"
                        >
                        </message-ballon>
                    </div>
                    <!--</div>-->
                    <span v-if="pause_message" id="pause-message">
                        <i class="fa fa-robot"></i>
                        Processando
                        <span id="dot-1">.</span>
                        <span id="dot-2">.</span>
                        <span id="dot-3">.</span>
                    </span>
                    <span v-else-if="typing == true" id="pause-message">
                        <!-- <i class="fa fa-robot"></i> -->
                        Digitando
                        <span id="dot-1">.</span>
                        <span id="dot-2">.</span>
                        <span id="dot-3">.</span>
                    </span>
                    <span v-else>
                    </span>
                    <queue-wait-ballon
                        :number-queue="numberQueue"
                        :visible="visibleBallon"
                        :endAttendance="endedAttendance"
                    >
                    <!-- end chat-history -->
                    </queue-wait-ballon>
                </div>

                <div class="chat-message clearfix">
                    <button v-show="!endedAttendance" ref="upload_button" class="outline-none apply">
                        <label for="send-file" style="cursor: pointer">
                            <i class="fas fa-paperclip"></i>
                        </label>
                        <input type="file" id="send-file" accept="application/*, image/*, text/*" :disabled="disableInteraction" name="send-file" style="display:none" v-on:change="SendFile">
                    </button>
                    <textarea
                        v-show="!endedAttendance"
                        v-on:keyup.enter="SendMessage()"
                        ref="message_box"
                        :disabled="disableInteraction"
                        name="message-to-send"
                        id="message-to-send"
                        placeholder="Envie uma mensagem"
                        class="outline-none"
                        rows="2"
                        @keydown="Typing($event)"
                    ></textarea>
                    <div v-if="!(openingHoursChat.operatingChat) || widgetParapeters.id_status != 1" style="height: 38px"></div>
                    <button v-else-if="!endedAttendance" v-on:click="SendMessage" ref="send_button" id="send-button" class="outline-none send-button">
                        <i class="far fa-paper-plane"></i>
                    </button>
                    
                    <button v-else-if="endedAttendance" v-on:click="startNewAttendance" :class="button_modify" :style="styleObject" type="button">Iniciar novo atendimento</button>
                    <!--<button v-show="!newChat" v-on:click="startAttendance" class="button-restart-attendance" :style="styleObject" type="button">Iniciar atendimento</button>-->
                </div>
                <!-- end chat-message -->
            </div>
            <!-- end chat -->
        </div>
        <!-- end container -->
    </div>
</template>

<script>

import io from "socket.io-client";
import QueueWaitBallon from "../components/queueWaitBallon";
import MessageBallonMontreal from "../components/messageBallonMontreal";
import MessageBallon from "@/components/messageBallon";
var files = {},
    struct = {
        name: null,
        type: null,
        size: 0,
        data: [],
        slice: 0,
    };
export default {
    name: "Home",
    computed:{
        styleObject: function() {
            return {
                '--color': this.secondary_color,
            }
        }
    },
    data() {
        return {
            io: io(process.env.VUE_APP_SOCKET_ENDPOINT),
            numberQueue: 0,
            visibleBallon: false,
            operator_socket_id: "",
            secondary_color: this.$parent.secondary_color,
            endedAttendance: this.$parent.newChat,
            filaChat: false,
            iniciarChat: false,
            filas: '',
            newChat: this.$parent.newChat,
            mensagens: [],
            pageTitle: document.title,
            showingNotification: false,
            uploadedFile: {},
            pause_message: false,
            openingHoursChat: this.$parent.openingHoursChat,
            mode: this.$parent.mode,
            disableInteraction: true,
            widgetParapeters: this.$parent.widgetParapeters,
            typing: false,
            extension: true,
            button_modify:this.$parent.company == 100 ? 'button-restart-attendance-montreal': 'button-restart-attendance',
        };
    },
    methods: {
        insertNewAttendance: function (){
            this.endedAttendance = true;
            this.visibleBallon = false;
        },
        startNewAttendance: function (){
            this.$emit('encerraSessao');
        },
        RenderMessage: function(message, author, type) {
            if(this.pause_message !== false && author === 'Atendente'){
                this.pause_message = false;
            }
            message.type = type;
            message.author = author;

            this.mensagens.push(message);
            return this.mensagens[this.mensagens.length - 1];
        },
        escolheOpcao: function(opcao){
            document.querySelector('#message-to-send').value = opcao;
            document.querySelector('#send-button').click();
            // this.RenderMessage({message: opcao},'Eu', 'text');
        },

        SendMessage: function() {
            var message = document.getElementsByName("message-to-send")[0].value;
            document.getElementsByName("message-to-send")[0].value = '';
            if(!(message.length === 0 || !message.trim())){
                this.disableInteraction = false;
                var message_object = {
                    author: '',
                    message: message
                };
                this.RenderMessage(message_object, 'Eu', 'text');
                this.io.emit("send_message", {
                    socket_id: this.operator_socket_id,
                    message,
                    filaChat: this.filaChat
                });
            }
        },
        VerifyFileExtensions(fileName){
            if(fileName.toUpperCase().includes('.EXE') || fileName.toUpperCase().includes('.BAT') 
            || fileName.toUpperCase().includes('.VBS') || fileName.toUpperCase().includes('.APK') 
            || fileName.toUpperCase().includes('.APP') || fileName.toUpperCase().includes('.CMD')){
                return false
            }
            return true
        },

        CloseNotifyExtension(){
            this.extension = true;
        },

        SendFile: function (event){
            let file = event.target.files[0];
            this.extension = this.VerifyFileExtensions(file.name);
            if(!this.extension){
                setTimeout(this.CloseNotifyExtension, 4000);
                return;
            }
            if (typeof file === 'undefined' || file.length === 0) {

            }
            else{
                let fileReader = new FileReader();
                let slice = file.slice(0, 100000);

                fileReader.readAsArrayBuffer(slice);
                this.uploadedFile = {
                    file: file,
                    fileReader: fileReader,
                };

                let blob = new Blob([this.uploadedFile.file], {type: this.uploadedFile.file.name});
                let objectUrl = URL.createObjectURL(blob);
                let message = {
                    message: this.uploadedFile.file.name,
                    fileUrl: objectUrl,
                    file: {
                        downloading: true,
                        progress: 0,
                    }
                }
                this.uploadedFile.messageLocation = this.RenderMessage(message,'Eu', 'file')

                this.SendFileSlice();

            }
        },
        SendFileSlice(){
            this.uploadedFile.fileReader.onload = (evt) => {
                var arrayBuffer = this.uploadedFile.fileReader.result;

                var dataFile = {
                    name: this.uploadedFile.file.name,
                    type: this.uploadedFile.file.type,
                    size: this.uploadedFile.file.size,
                    data: arrayBuffer,
                };
                this.io.emit("client-send-file-slice", {
                    socket_id: this.operator_socket_id,
                    file: dataFile,
                    clientData: this.filaChat
                });
            }
        },
        setCookie(cname, cvalue, exdays) {
            let d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            let expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }, 
        registraNaFila(){
            //Registra usuario na fila
            this.io.emit("RegisterQueue", {
                type: "client",
                clientData: this.$parent.filledFieds,
                codEmpresa: this.$parent.company,
                recoveredFilaChatId: this.$parent.recoveredFilaChatId,
                widgetParapeters: this.$parent.widgetParapeters,
                id_canal_cadastro: this.$parent.widget,
                id_contato: this.$parent.id_contato,
                uuid: this.$parent.uuid
            });
        },
        
        Typing(event){
            if(this.filaChat.id_agente != null){
                if(event.key == 'Backspace' || event.key == 'Enter' || event.key == 'Delete')
                    this.io.emit("TypingClient", false, {
                        operator_socket_id: this.operator_socket_id,
                        id_registro: this.filaChat.id_registro
                    });
                else if (event.key != 'Enter')
                    this.io.emit("TypingClient", true,  {
                        operator_socket_id: this.operator_socket_id,
                        id_registro: this.filaChat.id_registro
                    });
            }
        },
    },
    components: {
        MessageBallon,
        QueueWaitBallon,
        MessageBallonMontreal
    },
    mounted() {
        if(this.endedAttendance && this.mode === 'mobile' && this.openingHoursChat && this.openingHoursChat.operatingChat){
            this.startNewAttendance();
        }
        this.io.on("connect", () => {
            if(this.filaChat !== false){
                this.io.emit('reconectaCliente', {id_fila_chat: this.filaChat.id_registro});
            }
        });
        this.io.on("atualizafilaChatCliente",(filaChat)=>{
            this.filaChat = filaChat;
        });
        //Obtem a posição na fila
        this.io.on("PositionQueue",(position)=>{
            this.numberQueue = position;
        });
        this.io.on("saveCookie",(token)=>{
            if(this.mode == 'mobile')
                this.setCookie('cosmos_widget_token', token, 7);
            else
                window.parent.postMessage({type: 'token', token: token}, '*');
        });
        // Atualiza a posição na fila quando necessaria
        //TODO sem uso - adaptar para funcionar sem o formulário
        // this.io.on("UpdateQueuePosition",()=>{
        //     this.io.emit("UpdateQueuePosition",{fila:this.id_fila});
        // })
        this.io.on("emFluxo", data => {
            this.disableInteraction = false;
            this.visibleBallon = false;
        });

        this.io.on("OpenChat", data => {
            this.disableInteraction = false;
            this.visibleBallon = false;
            this.operator_socket_id = data;
            // window.parent.postMessage({type: 'notify-client'}, '*');
        });
        this.io.on("emEspera", data => {
            // this.disableInteraction = true;
            // this.visibleBallon = true;
            this.operator_socket_id = '';
        });

        this.io.on("receivedMessage", (message, id_message = 0, disableInteraction = false) => {
            this.disableInteraction = disableInteraction;
            if(disableInteraction)
                this.visibleBallon = true;
            window.parent.postMessage({type: 'notify-client'}, '*');
            if(message != null){
                // if(id_message != 0 || id_message != null ){
                //     this.io.emit("messagered", id_message);
                // } 
                this.RenderMessage({message: message}, 'Atendente', 'text');
                this.typing = false;
            }
        });
        this.io.on("receivedPauseMessage", async ({tempo}) => {
            this.pause_message = true;
            setTimeout(() => {this.pause_message = false}, tempo)
        });
        this.io.on("receivedMessageChoiceOptions", (data) => {
            this.disableInteraction = true;
            window.parent.postMessage({type: 'notify-client'}, '*');
            this.RenderMessage(data, 'Atendente', 'text');
        });

        this.io.on("client-receive-file-slice", (data) => {
            var file = data.file;
            if (!files[file.name]) {
                files[file.name] = Object.assign({}, struct, file);
                files[file.name].data = [];
            }

            file.data = new Buffer(new Uint8Array(file.data));
            //save the data
            files[file.name].data.push(file.data);
            files[file.name].slice++;
            if (files[file.name].slice * 100000 >= files[file.name].size) {


                var fileBuffer = Buffer.concat(files[file.name].data);

                var blob = new Blob([fileBuffer], {type: files[file.name].type});
                var objectUrl = URL.createObjectURL(blob);
                let message = {
                    message: files[file.name].name,
                    fileUrl: objectUrl
                }
                window.parent.postMessage({type: 'notify-client'}, '*');
                this.RenderMessage(message,'Atendente', 'file');
                this.io.emit("client-received-full-file", {
                    socket_id: this.operator_socket_id,
                    data: data.data
                });
            } else {

                this.io.emit("client-request-file-slice", {
                    socket_id: this.operator_socket_id,
                    currentSlice: files[file.name].slice,
                    data: data.data
                });
            }

        });
        this.io.on("operator-request-file-slice", data => {
            var place = data.currentSlice * 100000;
            var slice = this.uploadedFile.file.slice(place, place + Math.min(100000, this.uploadedFile.file.size - place));

            this.uploadedFile.messageLocation.file.progress = (((place * 100) / this.uploadedFile.file.size).toFixed(0));
            this.uploadedFile.fileReader.readAsArrayBuffer(slice);
            this.SendFileSlice();

        });
        this.io.on("operator-received-full-file", data => {
            this.uploadedFile.messageLocation.file.progress = 100;
            this.uploadedFile.messageLocation.file.downloading = false;

        });
        this.io.on("loadMessageHistory", async ({messageHistory, ended}) => {
            await messageHistory.forEach(function (message) {
                let msg = {
                    message: message.mensagem,
                    fileUrl: message.filepath
                }
                let author = (message.cliente === '0') ? 'Atendente' : 'Eu';
                let type = (message.filepath === null) ? 'text' : 'file';
                this.RenderMessage(msg, author, type);
            }, this);
            if(ended){
                this.insertNewAttendance();
            }
            else {
                this.disableInteraction = false;
            }
        });
        this.io.on("endattendance", (message) => {
            if(message){
                // window.parent.postMessage({type: 'notify-client'}, '*');
                this.RenderMessage({message: message},'Atendente', 'text');
            }
            this.disableInteraction = true;


            this.insertNewAttendance();
            this.io.disconnect(true);
        });
        this.io.on("Typing", (typing) => {
            this.typing = typing;
        });

        // this.registraNaFila();
        if(this.newChat === false){
            this.registraNaFila();
        }
    }
};
</script>
